import { render, staticRenderFns } from "./AssetTableTrade.vue?vue&type=template&id=564c84a6&scoped=true&"
import script from "./AssetTableTrade.vue?vue&type=script&lang=js&"
export * from "./AssetTableTrade.vue?vue&type=script&lang=js&"
import style0 from "./AssetTableTrade.vue?vue&type=style&index=0&id=564c84a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564c84a6",
  null
  
)

export default component.exports